module.exports = "/images/quincho.svg?8ae5157bb2dd06375ecb05954e1238c0";